export default "__VITE_ASSET__D2V88gtG__"